import React, { useState, useEffect } from "react";
import { Modal, TransferUser } from "@cloud/atom-ui";
import { getAdministrators } from "../thunk";
const VisitableScope = (props) => {
  const { showAdminModal, id, adminUserData } = props;
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState();
  const [finalSelected, setFinalSelected] = useState([]);

  useEffect(() => {
    if (adminUserData && adminUserData.length > 0) {
      let arr = [];
      Object.keys(adminUserData).forEach((v) => {
        let o = {
          title: adminUserData[v].chineseName
            ? adminUserData[v].chineseName
            : "--",
          key: adminUserData[v].accountId,
          isLeaf: true,
          isUser: true,
        };
        arr.push(o);
      });
      setSelected(arr);
      setFinalSelected(arr);
    } else {
      setSelected([]);
    }
  }, []);
  useEffect(() => {
    getAdminDta();
  }, []);
  //根据人员roleCode字段获取对应的标签名
  const getTagByRoleCode = (roleCode) => {
    if (!roleCode) return "";
    let roleCodeMap = {
      enterpriseAdmin: "租户管理员",
      appStoreAdmin: "应用管理员",
    };
    return ` (${roleCodeMap[roleCode]})`;
  };
  // 获取应用管理员
  const getAdminDta = (keyword) => {
    getAdministrators(id, keyword ? keyword : "").then((res) => {
      if (res.status === 1) {
        let data = res.data;
        let obj = data.contactUserVOS;
        let arr = [
          {
            isUser: true,
            groupName: "人员",
            data: [],
          },
        ];
        Object.keys(obj).forEach((v) => {
          let o = {
            title: `${
              obj[v].chineseName ? obj[v].chineseName : "--"
            }${getTagByRoleCode(obj[v].roleCode)}`,
            key: obj[v].accountId,
            isLeaf: true,
            isUser: true,
          };
          arr[0].data.push(o);
        });
        setData([...arr]);
      } else {
        setData([]);
      }
    });
  };
  const handleOk = () => {
    props.getSelected(finalSelected);
    props.closeModel();
  };
  const handleCancel = () => {
    props.getSelected(selected);
    props.closeModel();
  };

  const renderSelectedTitle = (selectedData) => {
    let title = "";
    if (!selectedData?.length) {
      return title;
    }
    if (selectedData) {
      const userNum = selectedData?.filter((item) => item?.isUser)?.length;
      const deptNum = selectedData?.filter(
        (item) => !item?.isUser && !("roleType" in item)
      )?.length;
      const roleNum = selectedData?.filter(
        (item) => !("isUser" in item) && "roleType" in item
      )?.length;
      const userTitle = userNum ? `人员${userNum}` : "";
      const deptTitle = deptNum ? `部门${deptNum}` : "";
      const roleTitle = roleNum ? `角色${roleNum}` : "";
      title = [deptTitle, roleTitle, userTitle]
        .filter((item) => item && item?.trim())
        ?.join("，");
    }
    return `（${title}）`;
  };

  useEffect(() => {
    const titleDom = document.getElementsByClassName(
      "amu-td-layout-header"
    )?.[1]?.children?.[0];
    if (titleDom) {
      titleDom.innerHTML = renderSelectedTitle(finalSelected);
    }
  },[finalSelected]);

  return (
    <Modal
      title="添加人员"
      visible={showAdminModal}
      onOk={() => {
        handleOk();
      }}
      onCancel={() => {
        handleCancel();
      }}
      width={800}
    >
      <TransferUser
        data={data}
        checkedNodes={selected}
        searchPlaceholder="按姓名搜索人员"
        onChange={(_, nodes) => {
          setFinalSelected(nodes);
        }}
        onSearch={(value) => getAdminDta(value)}
      />
    </Modal>
  );
};
export default VisitableScope;
